import { useContext, useEffect, useState } from "react";
import { StoreContext } from "../../../store/Store";
import { LocalStoreContext } from "../store/LocalStore";
import { RefContext } from "../store/RefContext";
import { actionTypes } from "../../../store/storeTypes";
import { Loader } from "../../../components/loader/Loader";
import Gradient from "javascript-color-gradient";

const colorArr = new Gradient()
  .setColorGradient("#be1c1c", "#FFFFFF", "#13b513")
  .setMidpoint(25)
  .getColors();

const controlsToSet = [
  "ticker",
  "FairValue1",
  "spiderTicker",
  "storedValueTicker",
];

export const TableView = () => {
  const [store, dispatch] = useContext(StoreContext);
  const [lstore] = useContext(LocalStoreContext);
  const refs = useContext(RefContext);
  const { relativeperformance } = lstore;
  const [totalData, setTotalData] = useState();
  const { defaultTicker, controlPopupMenu } = store;

  const tableStyle = { border: "none", margin: 0 };

  const headStyle = {
    fontSize: 12,
    fontWeight: 800,
    textAlign: "right",
  };
  const columnStyle = {
    paddingLeft: 10,
    paddingRight: 10,
  };
  const bodyStyle = {
    fontSize: 12,
    fontWeight: 700,
    textAlign: "right",
  };
  const gapStyle = { width: 20 };
  const boxStyle = { width: 80, paddingRight: 6, cursor: "pointer" };
  const detailStyle = {
    textAlign: "left",
    cursor: "pointer",
  };

  useEffect(() => {
    if (relativeperformance.rawdata.length > 0) {
      const ndata = {};
      relativeperformance.rawdata
        .filter((row) => {
          return row.Column_2 !== "Ticker_x" && row.Column_2 !== "Ticker_Match";
        })
        .forEach((item) => {
          if (item.Column_2 in ndata) {
            ndata[item.Column_2].push({
              horizon: item.Column_68,
              vscore: item.Column_54,
            });
          } else {
            ndata[item.Column_2] = [
              {
                horizon: item.Column_68,
                vscore: item.Column_54,
              },
            ];
          }
        });
      const tdata = [];
      Object.entries(ndata).forEach((item) => {
        tdata.push({
          ticker: item[0],
          total: item[1]
            .map((item) => +item.vscore)
            .reduce((total, val) => total + val),
        });
      });
      setTotalData(
        tdata.sort((a, b) =>
          a.ticker > b.ticker ? 1 : a.ticker < b.ticker ? -1 : 0
        )
      );
    }
  }, [relativeperformance]);

  const onClick = (ev, ticker) => {
    ev.preventDefault();
    ev.stopPropagation();
    let newSelection = controlPopupMenu.selected;

    Object.keys(newSelection)
      .filter((fitem) => controlsToSet.includes(fitem))
      .forEach((item) => {
        newSelection[item] = ticker;
      });

    dispatch({
      type: actionTypes.SET_CONTROL_POPUP_MENU,
      payload: {
        ...controlPopupMenu,
        showPopup: false,
        selected: newSelection,
      },
    });
    dispatch({
      type: actionTypes.SET_DEFAULT_TICKER,
      payload: ticker,
    });
  };

  const columnOfTickers = (from, to) => {
    return (
      <table style={tableStyle}>
        <thead style={headStyle}>
          <tr>
            <td></td>
            <td style={gapStyle}></td>
            <td>V-Score</td>
          </tr>
        </thead>
        <tbody style={bodyStyle}>
          {totalData
            .filter((item, i) => i >= from && i < to)
            .map((item, i) => {
              return (
                <tr key={i} onClick={(ev) => onClick(ev, item.ticker)}>
                  <td
                    style={{
                      ...detailStyle,
                      border:
                        defaultTicker === item.ticker
                          ? "2px solid #000000"
                          : "none",
                    }}
                  >
                    {item.ticker}
                  </td>
                  <td style={gapStyle}></td>
                  <td
                    style={{
                      ...{
                        backgroundColor: colorArr[item.total + 12],
                      },
                      ...boxStyle,
                    }}
                  >
                    {item.total || item.total === 0 ? item.total : 999}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    );
  };

  const columns = 6;
  const columnArray = [...Array(columns).keys()];
  const rowsPerColumn = totalData
    ? Math.ceil(totalData.length / columnArray.length)
    : null;

  return totalData ? (
    <div
      ref={refs.relativePerformance}
      style={{
        height: refs.componentSize.current["TableView"].height,
        width: refs.componentSize.current["TableView"].width - 17,
        margin: 0,
        display: "flex",
        justifyContent: "center",
      }}
    >
      {columnArray.map((item, i) => {
        return (
          <div key={i} style={columnStyle}>
            {columnOfTickers(
              i * rowsPerColumn,
              i * rowsPerColumn + rowsPerColumn
            )}
          </div>
        );
      })}
    </div>
  ) : (
    <Loader />
  );
};
